export const routesPath = {
  home: "/",
  login: "/login",
};
